<template>
  <search-select
    :options="managers"
    v-model="managerInput"
    placeholder="менеджер"
    :search-enabled="false"
    bg="dark"
  ></search-select>
</template>

<script>
import SearchSelect from '@/components/ui/SearchSelect.vue'
import { DataService } from '@/services/DataService.js'

export default {
  props: ['field', 'form', 'state'],
  components: {
    SearchSelect
  },
  computed: {
    value () {
      return this.field.value
    },
    // TODO: кривизна! сюда надо передать company_id!
    companyId () { return this.state.counteragent_company_id.value },
    managerInput: {
      get () { return this.managerIdx },
      set (idx) {
        this.managerIdx = idx
        const managerId = Number.isInteger(this.managerIdx)
          ? this.managers[this.managerIdx].id
          : null
        this.$emit('input', { value: managerId, debounced: false })
      }
    }
  },
  watch: {
    companyId: {
      immediate: true,
      handler: function (id) {
        this.loadManagers(id)
      }
    }
  },
  data () {
    return {
      managers: [],
      managerIdx: null,
      loadManagers: async (companyId) => {
        this.$emit('editing', true)
        return DataService.getManagers({ companyId: companyId })
          .then(({ data: { managers } }) => {
            this.managers = managers
            if (this.value) {
              const idx = this.managers.findIndex((m) => m.id === this.value)
              this.managerIdx = idx > -1 ? idx : null
            } else {
              this.managerIdx = null
            }
          })
          .finally(() => {
            this.$emit('editing', false)
          })
      }
    }
  }
}
</script>
